import { render, staticRenderFns } from "./purpleButton.vue?vue&type=template&id=21f04b16&scoped=true&"
import script from "./purpleButton.vue?vue&type=script&lang=ts&"
export * from "./purpleButton.vue?vue&type=script&lang=ts&"
import style0 from "./purpleButton.vue?vue&type=style&index=0&id=21f04b16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f04b16",
  null
  
)

export default component.exports